import { ChangeDetectionStrategy, Component, Input, Self, ViewChild } from '@angular/core';
import { AutocompleteFormControlComponent, DynamicFormService } from 'core/dynamic-form';
import { pairBehaviorSubjects } from 'core/rx-js';
import { filter, Subject, takeUntil } from 'rxjs';
import { RemoteActorService } from '../../../../../remotes/remote-actor.service';
import { SelectActivitiesStepService } from '../../../select-activities-step.service';
import { ActivityItemService } from '../activity-item.service';
import { ActorService } from './actor.service';

@Component({
  selector: 'ss-actor',
  templateUrl: './actor.component.html',
  styleUrls: ['./actor.component.scss'],
  providers: [
    RemoteActorService,
    ActorService,
    DynamicFormService,
  ],
  host: {
    class: 'flex-row flex--align-start'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ActorComponent {
  readonly #destroy = new Subject<void>()
  readonly mainFormGroupSubject = this._actorService.mainFormGroupSubject;
  readonly configDisabledObs = this._actorService.configDisabledObs;
  readonly actorSubject = this._actorService.actorSubject;
  readonly suffixTemplateSubject = this._actorService.suffixTemplateSubject
  @Input() get suffixTemplate() {
    return this.suffixTemplateSubject.value
  }
  set suffixTemplate(value) {
    this.suffixTemplateSubject.next(value)
  }

  readonly actorIdSubject = this._actorService.actorIdSubject;
  @Input() get actorId() {
    return this.actorIdSubject.value
  }
  set actorId(value) {
    if (value === this.actorId) {
      return;
    }
    this.actorIdSubject.next(value)
  }


  @ViewChild('autocompleteRef')
  private _userAutoComplete: AutocompleteFormControlComponent

  readonly selectedUserSubject = this._actorService.selectedUserSubject;
  readonly triedNextObs = this._selectActivitesStepService.triedNextObs;



  constructor(
    @Self() private readonly _actorService: ActorService,
    private readonly _activityItemService: ActivityItemService,
    private readonly _selectActivitesStepService: SelectActivitiesStepService,
    private readonly _dynamicFormService: DynamicFormService
  ) {

    pairBehaviorSubjects(this.mainFormGroupSubject, this._activityItemService.mainFormGroupSubject)

    this.triedNextObs
      .pipe(filter(Boolean), takeUntil(this.#destroy))
      .subscribe(() => this._dynamicFormService.submittedSubject.next(true))
  }

  ngAfterViewInit() {

    pairBehaviorSubjects(this.selectedUserSubject, this._userAutoComplete.selectedItemSubject);

  }

  toggleExpanded() {

    this._actorService.openConfig()

  }



  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
